import { BYTES_GIGABYTE } from '@air/utilities';

// Safari 27 aborts the tab when an image load flattens a buffer past 2GiB.
// Local previews stop at 1GB so the original file is never that image.
export const BROWSER_IMAGE_PREVIEW_MAX_FILE_SIZE_BYTES = BYTES_GIGABYTE;

export const exceedsBrowserImagePreviewLimit = (sizeBytes: number) =>
  sizeBytes > BROWSER_IMAGE_PREVIEW_MAX_FILE_SIZE_BYTES;
